import { omit } from 'lodash';
import { GET_PERSONA_AFFERENZA } from 'uniba-volto-persone/actions';


const initialState = {
    error: null,
    items: [],
    total: 0,
    loaded: false,
    loading: false,
    batching: {},
    subrequests: {},
};

/**
 * querystringsearch reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function personaAfferenzaReducer(state = initialState, action = {}) {
    switch (action.type) {
        case `${GET_PERSONA_AFFERENZA}_PENDING`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            ...(state.subrequests[action.subrequest] || {
                                items: [],
                                total: 0,
                                batching: {},
                            }),
                            error: null,
                            loaded: false,
                            loading: true,
                        },
                    },
                }
                : {
                    ...state,
                    error: null,
                    loading: true,
                    loaded: false,
                };
        case `${GET_PERSONA_AFFERENZA}_SUCCESS`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            error: null,
                            items: {
                                ...state.subrequest[action.subrequest]?.items,
                                [action.path]: action.result
                            },
                            total: action.result.length,
                            loaded: true,
                            loading: false,
                            batching: { ...action.result.batching },
                        },
                    },
                }
                : {
                    ...state,
                    error: null,
                    items: {
                        ...state.items, 
                        [action.path]: action.result
                    },
                    total: action.result.length,
                    loaded: true,
                    loading: false,
                    batching: { ...action.result.batching },
                };
        case `${GET_PERSONA_AFFERENZA}_FAIL`:
            return action.subrequest
                ? {
                    ...state,
                    subrequests: {
                        ...state.subrequests,
                        [action.subrequest]: {
                            error: action.error,
                            items: [],
                            total: 0,
                            loading: false,
                            loaded: false,
                            batching: {},
                        },
                    },
                }
                : {
                    ...state,
                    error: action.error,
                    items: [],
                    total: 0,
                    loading: false,
                    loaded: false,
                    batching: {},
                };
        default:
            return state;
    }
}
